// extracted by mini-css-extract-plugin
export default {"root":"ArticleItem_root__LVCpV","header":"ArticleItem_header__ocF7o","headerContent":"ArticleItem_headerContent__8eGdn","body":"ArticleItem_body__3u4m2"};